(function() {
  var qs = window.MidYearSaleUtils.qs;
  var qsa = window.MidYearSaleUtils.qsa;
  var addItems = window.MidYearSaleUtils.addItems;

  function setProcessing(button) {
    var spinnerColor = button.classList.contains('mys-btn--outline') ? '#0062C4' : '#FFFFFF';
    button.style.width = button.offsetWidth + 'px';
    button.classList.add('is-processing');
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = window.MidYearSaleUtils.processingSpinnerHtml(spinnerColor);
  }

  function clearProcessing(button, html) {
    button.classList.remove('is-processing');
    button.removeAttribute('aria-busy');
    button.innerHTML = html;
    button.style.width = '';
  }

  function initProductActions(root) {
    root.addEventListener('click', function(event) {
      var addButton = event.target.closest('[data-mys-add-cart]');
      var buyButton = event.target.closest('[data-mys-buy-now]');
      var button = addButton || buyButton;
      if (!button || button.disabled) return;

      var variantId = Number(button.dataset.variantId);
      if (!variantId) return;
      event.preventDefault();

      var oldHtml = button.innerHTML;
      button.disabled = true;
      setProcessing(button);

      addItems([{ id: variantId, quantity: 1 }])
        .then(function() {
          if (buyButton) {
            window.location.href = '/checkout';
            return;
          }
          clearProcessing(button, oldHtml);
          button.textContent = button.dataset.added || 'Added';
          window.setTimeout(function() {
            button.innerHTML = oldHtml;
            button.disabled = false;
          }, 1200);
        })
        .catch(function(error) {
          clearProcessing(button, oldHtml);
          button.disabled = false;
          window.alert(error.message || 'Unable to add item.');
        });
    });
  }

  function initTabs(root) {
    var tabsRoot = qs(root, '[data-mys-tabs-root]');
    if (!tabsRoot) return;
    qsa(tabsRoot, '[data-mys-tablist]').forEach(function(list) {
      var group = list.dataset.mysTablist;
      list.addEventListener('click', function(event) {
        var button = event.target.closest('[data-mys-tab]');
        if (!button) return;
        var tab = button.dataset.mysTab;
        qsa(list, '[data-mys-tab]').forEach(function(item) {
          item.classList.toggle('is-active', item === button);
        });
        qsa(tabsRoot, '[data-mys-panel-group="' + group + '"]').forEach(function(panel) {
          panel.hidden = panel.dataset.mysPanel !== tab;
        });
      });
    });
  }

  function initRemainingGifts(root) {
    qsa(root, '[data-mys-remaining-gifts]').forEach(function(wrap) {
      if (wrap.dataset.mode === 'manual') return;
      var limit = Math.max(0, Number(wrap.dataset.limit || 50));
      var resetHour = Number(wrap.dataset.resetHour || 5);
      var count = qs(wrap, '[data-mys-remaining-count]');
      if (!count || !limit) return;

      function update() {
        var now = Date.now();
        var beijingOffset = 8 * 60 * 60 * 1000;
        var beijingNow = new Date(now + beijingOffset);
        var reset = Date.UTC(
          beijingNow.getUTCFullYear(),
          beijingNow.getUTCMonth(),
          beijingNow.getUTCDate(),
          resetHour,
          0,
          0
        ) - beijingOffset;
        if (now < reset) reset -= 24 * 60 * 60 * 1000;

        var dayMs = 24 * 60 * 60 * 1000;
        var elapsed = Math.max(0, now - reset);
        var consumed = Math.floor((elapsed / dayMs) * limit);
        count.textContent = String(Math.max(0, limit - consumed));
      }

      update();
      window.setInterval(update, 60000);
    });
  }

  function boot(root) {
    qsa(root, '[data-mid-year-free-gifts]').forEach(function(section) {
      if (section.dataset.boundFreeGifts === 'true') return;
      section.dataset.boundFreeGifts = 'true';
      initTabs(section);
      initRemainingGifts(section);
      initProductActions(section);
    });
  }

  function init() {
    boot(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(event) {
    if (!event.detail || !event.detail.sectionId) return;
    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (section) boot(section);
  });
})();
